import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TextField from "./TextField";
import Spacer from "./Spacer";
// import PopupBackground from "../../assets/images/union.png";

const MOBILE_BREAK = "480px";

const StrengthBar = styled.div`
  width: 81px;
  height: 6px;
  background-color: ${({ active }) => (active ? "#2DC4CF" : "#B8EBEF")};
  border-radius: 3px;
  margin-right: 4px;

  @media (max-width: ${MOBILE_BREAK}) {
    flex: 1 1 48%; /* two per row, ~4% gap from justify-content */
    width: auto;
    margin-bottom: 4px;
  }
`;

const StrengthBarsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RulesPopup = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(212px, -220px);
  left: 50%;

  background: white;
  border: 1px solid #ced4da;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: ${({ show }) => (show ? "block" : "none")};
  z-index: 10;

  @media (max-width: ${MOBILE_BREAK}) {
    width: 100%;
    max-width: 320px;
    transform: translate(-50%, -50%);
    top: 30%;
  }
`;

const Rule = styled.div`
  color: "#161718";
  text-decoration: ${({ fulfilled }) => (fulfilled ? "line-through" : "none")};
  line-height: 20px;

  &::before {
    content: "•";
    margin-right: 8px;
    color: "#161718";
  }
`;

const RuleDescription = styled.div`
  color: #6c757d;
`;

const PasswordStrength = ({ onChange, value, onRulesFulfilled }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [fulfilledRules, setFulfilledRules] = useState([
    false,
    false,
    false,
    false,
  ]);

  useEffect(() => {
    const newFulfilledRules = [
      value.length >= 8, // At least 8 characters
      /[A-Z]/.test(value), // Contains an uppercase letter
      /\d/.test(value), // Contains a number
      /[!@#$%^&*(),.?":{}|<>]/.test(value), // Contains a symbol
    ];
    setFulfilledRules(newFulfilledRules);
    onRulesFulfilled(newFulfilledRules); // Notify parent componen
  }, [value, onRulesFulfilled]);

  return (
    <div>
      <RulesPopup show={showPopup}>
        <RuleDescription>Make sure your password has:</RuleDescription>
        <Spacer />
        <Rule fulfilled={fulfilledRules[0]}>At least 8 characters</Rule>
        <Rule fulfilled={fulfilledRules[1]}>At least one capital letter</Rule>
        <Rule fulfilled={fulfilledRules[2]}>At least one number</Rule>
        <Rule fulfilled={fulfilledRules[3]}>At least one symbol</Rule>
        <Spacer />
        <RuleDescription>
          A strong password helps <br />
          you to improve the safety <br />
          of your account
        </RuleDescription>
      </RulesPopup>

      <TextField
        type="password"
        id="password"
        name="password"
        placeholder="Enter new password"
        onChange={onChange}
        value={value}
        required
        onFocus={() => setShowPopup(true)}
        onBlur={() => setShowPopup(false)}
        maxLength={64}
      />
      <Spacer />

      <StrengthBarsWrapper>
        {fulfilledRules.map((rule, index) => (
          <StrengthBar key={index} active={rule} />
        ))}
      </StrengthBarsWrapper>
    </div>
  );
};

export default PasswordStrength;
